import { WarehouseAttributes } from '@/types'
import { CreateWarehouseMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
  } = useForm<CreateWarehouseMutation, WarehouseAttributes, never, never>({
    defaultValues: {
      name: '',
    },
    mutation: CreateMutation,
    resultKey: 'createWarehouse',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createWarehouse?.warehouse?.id) return

    navigate(`/settings/warehouses/${mutationData?.createWarehouse?.warehouse?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      <div className="grid grid-cols-3 gap-6">
        { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
        { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
        { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
        { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
        { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
        { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
